import { render, staticRenderFns } from "./observed_9.vue?vue&type=template&id=056be941&scoped=true&"
var script = {}
import style0 from "./observed_9.vue?vue&type=style&index=0&id=056be941&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056be941",
  null
  
)

export default component.exports